import { render, staticRenderFns } from "./LabelBase.vue?vue&type=template&id=386cd122&scoped=true&lang=pug&"
import script from "./LabelBase.vue?vue&type=script&lang=ts&"
export * from "./LabelBase.vue?vue&type=script&lang=ts&"
import style0 from "./LabelBase.vue?vue&type=style&index=0&id=386cd122&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386cd122",
  null
  
)

export default component.exports